const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M82.12,155.74a8.34,8.34,0,0,1,8.34-8.35h125a8.55,8.55,0,0,1,8.63,7.8,8.36,8.36,0,0,1-8.34,8.91H90.47a8.34,8.34,0,0,1-8.35-8.34Zm267.34,53.48a8.35,8.35,0,0,0-8.35-8.36H90.76a8.54,8.54,0,0,0-8.62,7.8,8.34,8.34,0,0,0,8.33,8.91H341.11a8.34,8.34,0,0,0,8.35-8.34Zm-7.92,45.11H90.76a8.54,8.54,0,0,0-8.62,7.8A8.35,8.35,0,0,0,90.47,271H341.54a8.36,8.36,0,0,0,8.36-8.36h0A8.35,8.35,0,0,0,341.54,254.33ZM90.47,307.8a8.34,8.34,0,0,0-8.33,8.91,8.54,8.54,0,0,0,8.62,7.8H321.54a8.36,8.36,0,0,0,8.36-8.36h0a8.35,8.35,0,0,0-8.36-8.35Zm0,165.42a25.14,25.14,0,0,1-25.06-25.07V63.85A25.14,25.14,0,0,1,90.47,38.78H257.56a16.71,16.71,0,0,1,16.71,16.7h0V88.91A41.79,41.79,0,0,0,316,130.68h33.42a16.09,16.09,0,0,1,11.78,4.93,16.38,16.38,0,0,1,4.93,11.78V249l16.71-26.9V147.39a33.62,33.62,0,0,0-9.78-23.64l-91.89-91.9a33.66,33.66,0,0,0-23.65-9.78H90.47A41.8,41.8,0,0,0,48.7,63.85v384.3a41.8,41.8,0,0,0,41.77,41.78H271.72l3-16.71Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.95 228.89 450.79 261.92 460.47 248.78 415.63 215.76 405.95 228.89 405.95 228.89",
    style: {
      fill: "#0096ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.98,
    y: 288.79,
    width: 139.86,
    height: 55.69,
    transform: "translate(-101.97 431.53) rotate(-53.63)",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.22,443.84a2.82,2.82,0,0,0,3.35,0l57.85-41.28-40-29.43L281.2,440.64a2.82,2.82,0,0,0,1,3.19Z",
    style: {
      fill: "#0096ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.4,184.26a27.93,27.93,0,0,0-38.93,5.91l-7.85,10.66,44.84,33,7.85-10.66a27.93,27.93,0,0,0-5.91-38.94Z",
    style: {
      fill: "#0096ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,87.89V95H94.84v6.2h16.85l-1.11,7.2h-25V75.36h25v7.2H94.84v5.33Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.69,98.4h9.41c.55,2.76,2.45,4.13,5.71,4.13q4.27,0,4.27-3a2.69,2.69,0,0,0-1.34-2.43,20.65,20.65,0,0,0-5.33-1.8q-6.81-1.64-9.26-4.13A8.55,8.55,0,0,1,125.7,85a9.24,9.24,0,0,1,3.36-7.34q3.36-2.88,9.94-2.88t10.13,2.88a10.11,10.11,0,0,1,3.79,7.2h-9.36q-.48-3.55-4.61-3.55-3.55,0-3.55,2.59a2.27,2.27,0,0,0,1.22,2.06,22.76,22.76,0,0,0,5.07,1.68q7.09,1.79,9.67,4.4a9,9,0,0,1,2.57,6.55,9.17,9.17,0,0,1-3.72,7.65q-3.74,2.86-10.78,2.86-6.68,0-10.42-2.86A11,11,0,0,1,124.69,98.4Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,75.36h9.74v33.08h-9.74Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.48,89.48v19H199a20.56,20.56,0,0,1-.63-3q-2.77,3.7-9.65,3.7-7.29,0-11.27-4.78a18.1,18.1,0,0,1-4-12q0-7.87,4.44-12.72t12.51-4.85q6.9,0,10.77,3.22a11.46,11.46,0,0,1,4.39,7.58H196c-.73-2.62-2.61-3.94-5.61-3.94q-6.92,0-6.91,10.37a20,20,0,0,0,.57,5,7.8,7.8,0,0,0,2.21,3.72,5.87,5.87,0,0,0,4.18,1.53,5.79,5.79,0,0,0,3.62-1A4.71,4.71,0,0,0,195.76,99a8.35,8.35,0,0,0,.36-2.5v-.24h-6.05V89.48Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.65,108.44h-8.88V75.36h11.61c.64,1.38,1.83,3.88,3.55,7.49s3.11,6.57,4.15,8.86,1.77,4,2.19,5.25h.19Q233,92.64,233,82.42V75.36h8.83v33.08h-11q-.37-.87-3.26-6.94t-4.63-10q-1.75-3.89-2.47-5.86h-.1q.33,3.66.34,15.32Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,449.08l6.48-7.62-40.7-34.59a14,14,0,0,0-23.06,10.66v6.05a4,4,0,0,1-6.81,2.82l-3-3a14,14,0,0,0-23.87,10,4,4,0,0,1-6.79,2.87l-42.55-41.73-7,7.14L166,443.39a14,14,0,0,0,23.79-10.06,4,4,0,0,1,6.81-2.85l3,3a14,14,0,0,0,23.87-9.9v-6.05a4,4,0,0,1,6.58-3Z",
    style: {
      fill: "#0096ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature6.05ce2e8c3a8a66ebe7b57ea7cd1d5867.svg";
export { ForwardRef as ReactComponent };